import styled, { css } from 'styled-components'
import { scale } from './animations'

export const inputStyles = () => css`
  width: 100%;
  padding: 6px 16px 16px 0;
  font-size: 16px;
  font-weight: normal;
  line-height: 1.2;
  color: var(--input-color-default, var(--color-main));
  border: none;
  caret-color: currentColor;

  ${props =>
    props.as === 'textarea' &&
    css`
      height: 42px;
    `}
`

const FormField = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 100%;
  padding-top: 16px;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;
    display: block;
    width: 100%;
    height: 2px;
    background-color: var(--field-line-color, var(--color-border));
    pointer-events: none;
    transition: background-color 0.3s ease;
  }

  ${props =>
    (props.focused || props.hasValue) &&
    css`
      --field-line-color: var(--color-decor);

      ${FormField.Label} {
        color: var(--color-main);
        opacity: 0.5;
        transform: scale(0.75) translateY(-30px);
      }

      ${FormField.Input} {
        opacity: 1;
      }
    `}

  ${props =>
    props.hasError &&
    css`
      --field-line-color: var(--color-error);
    `}

  ${props =>
    props.noDecor &&
    css`
      &::before {
        content: none;
      }
    `}

  ${props =>
    props.radio &&
    css`
      display: block;
    `}
`

FormField.Label = styled.label`
  position: absolute;
  top: 22px;
  left: 0;
  max-width: 100%;
  font-weight: normal;
  font-size: 16px;
  line-height: 1.2;
  color: var(--color-secondary);
  pointer-events: none;
  transform-origin: top left;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`

FormField.Title = styled(FormField.Label)`
  top: 0;
  display: inline-block;
  color: var(--color-main);
  opacity: 0.5;
  transform: scale(0.75);
`

FormField.Input = styled.input`
  ${inputStyles}
  opacity: 0;
  transition: opacity 0.3s linear;
`

FormField.ErrorIcon = styled.span`
  position: absolute;
  bottom: 16px;
  right: 0;
  display: block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: var(--color-error);
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMiIgaGVpZ2h0PSIxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMS43NjMgNi4xMTJhLjc2Ni43NjYgMCAwMS0xLjUzMiAwTC4wNzMuOTUzYS45MjUuOTI1IDAgMTExLjg0OCAwbC0uMTU4IDUuMTU5ek0uOTk3IDcuOTI4Yy4zMDEgMCAuNTQzLjA5Ny43MjQuMjkyLjE4Ni4xOTUuMjc5LjQ0NC4yNzkuNzQ3IDAgLjMtLjA5My41NDYtLjI3OS43NC0uMTgxLjE5Ni0uNDIzLjI5My0uNzI0LjI5M2EuOTU2Ljk1NiAwIDAxLS43MjUtLjI5MkExLjA0MyAxLjA0MyAwIDAxMCA4Ljk2OGMwLS4zLjA5LS41NDYuMjcyLS43NDFhLjk0NS45NDUgMCAwMS43MjUtLjI5OXoiIGZpbGw9IiNmZmYiLz48L3N2Zz4=');
  background-size: 2px 10px;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  animation: ${scale} 0.3s ease-in-out;
  animation-fill-mode: both;
  cursor: pointer;
`

FormField.Error = styled.div`
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.3;
  color: var(--color-error);
`

export default FormField
